import styled from 'styled-components';

import { TClearButtonStyledProps } from '@/shared/components/ui/button/clear-button/clear-button.types';
import { IconButton } from '@/shared/components/ui/button/icon-button/icon-button';

export const ClearIconButton = styled(IconButton)<TClearButtonStyledProps>`
  && {
    margin: 0.125rem -0.5rem;
      width: 2rem;
      height: 2rem;

    svg {
      rect {
        transition: fill 0.2s ease-in-out;
        fill: ${({ theme }) => theme.palette.text.secondaryLight};
      }
      path {
        transition: fill 0.2s ease-in-out;
        stroke: ${({ theme, $circle }) =>
          $circle
            ? theme.palette.background.paper
            : theme.palette.primary.main};
      }
    }

    &:hover {
      {({ $circle }) => $circle && 'background-color: unset;'};

      svg {
        rect {
          fill: ${({ theme }) => theme.palette.text.secondary};
        }
      }
    }
  }
`;
